import { render, staticRenderFns } from "./CourseDashboard.vue?vue&type=template&id=358bd61c&"
import script from "./CourseDashboard.vue?vue&type=script&lang=ts&"
export * from "./CourseDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports